import { useId } from "react";

/** One presentation for catalog cards, product pages and shop tiles. */
export default function HumanoidRobotImage({ image, className = "", decorative = false }) {
  const id = useId().replace(/:/g, "");
  const crop = image.crop || [0, 0, image.width, image.height];
  const [x, y, width, height] = crop;
  return (
    <>
    <div className={`humanoid-robot-image ${className}`}>
      <svg
        viewBox={crop.join(" ")}
        preserveAspectRatio="xMidYMid meet"
        role={decorative ? undefined : "img"}
        aria-label={decorative ? undefined : image.alt}
        aria-hidden={decorative || undefined}
        focusable="false"
        style={{ maxHeight: height * 1.5 }}
      >
        <defs>
          <clipPath id={`robot-frame-${id}`}>
            <rect x={x} y={y} width={width} height={height} />
          </clipPath>
          {image.clipPolygon && (
            <clipPath id={`robot-silhouette-${id}`}>
              <polygon points={image.clipPolygon} />
            </clipPath>
          )}
        </defs>
        <g clipPath={`url(#robot-frame-${id})`}>
          <image
            href={image.localPath}
            width={image.width}
            height={image.height}
            clipPath={image.clipPolygon ? `url(#robot-silhouette-${id})` : undefined}
          />
        </g>
      </svg>
    </div>
    {image.caption && !decorative && <p className="mt-3 text-sm leading-6 text-neutral-600">{image.caption}</p>}
    </>
  );
}
